import type { ModelWithNetStats } from '@cadstrom/sigma-engine-shared';
import type { CommandBarProviderProps } from '#components/command-bar/command-bar-types.js';

export const DESIGN_SEARCH_PREFIX = '/';
export const DESIGN_SEARCH_PROVIDER_ID = 'design-search';

export interface DesignSearchProviderProps extends CommandBarProviderProps {
	coreModel: ModelWithNetStats;
}
